import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import { Message, Tooltip, color } from '@nextiva/next-ui';
import styles from './ConditionalQuestionLabel.styles.scss';

export const TEST_ID = 'SurveyUI-ConditionalQuestionLabel';

export const conditionalLogicLabel = 'Conditional logic';

const ConditionalQuestionLabel = ({ enableMessage }) => {
  return (
    <Tooltip
      data-testid={`${TEST_ID}-Tooltip`}
      dark
      placement="right"
      text={enableMessage}
      popoverClassName={styles.tooltipPopover}
    >
      <Message
        data-testid={`${TEST_ID}-Message`}
        kind="info"
        blockName="nx-alert"
        containerStyle={{ margin: '10px 0px', color: color('gray-100') }}
        className={styles.message}
      >
        <FontAwesomeIcon
          icon={faInfoCircle}
          style={{ color: color('blue'), marginRight: '8px', fontSize: '16px' }}
        />
        Conditional logic
      </Message>
    </Tooltip>
  );
};

ConditionalQuestionLabel.propTypes = {
  enableMessage: PropTypes.string.required,
};

export default ConditionalQuestionLabel;
